"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var styles_1 = require("../../styles");
exports.IconButton = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled, secondary = _a.secondary, active = _a.active, outline = _a.outline, children = _a.children, rest = __rest(_a, ["onClick", "disabled", "secondary", "active", "outline", "children"]);
    return outline ? (React.createElement(StyledIconButtonOutlined, __assign({ secondary: secondary, active: active, outline: outline, onClick: onClick, disabled: disabled }, rest), children)) : (React.createElement(StyledIconButton, __assign({ secondary: secondary, active: active, outline: outline, onClick: onClick, disabled: disabled }, rest), children));
};
exports.IconButton.defaultProps = {
    secondary: false,
    outline: false,
    disabled: false,
    active: false
};
var StyledIconButton = styled_1.default.button(function (props) {
    var defaultStyle = {
        backgroundColor: props.secondary ? styles_1.palette['coral-base'] : styles_1.palette['blue-base']
    };
    var activeStyle = props.secondary
        ? {
            backgroundColor: styles_1.palette['coral-darker-40'],
            transform: 'translate(0px, 2px)',
            '&:hover:enabled': {}
        }
        : {
            backgroundColor: styles_1.palette['blue-darker-40'],
            transform: 'translate(0px, 2px)',
            '&:hover:enabled': {}
        };
    return __assign({ color: styles_1.palette['white-base'], height: '40px', width: '40px', padding: '6px', borderRadius: '20px', borderWidth: 0, '&:focus': {
            outline: 'none'
        }, '&:disabled': {
            backgroundColor: styles_1.palette['stone-lighter-40'],
            color: styles_1.palette['stone-darker-20'],
            cursor: 'not-allowed'
        }, '&:hover:enabled': {
            backgroundColor: props.secondary ? styles_1.palette['coral-darker-20'] : styles_1.palette['blue-darker-20'],
            cursor: 'pointer'
        }, '&:active:enabled': {
            backgroundColor: props.secondary ? styles_1.palette['coral-darker-40'] : styles_1.palette['blue-darker-40'],
            transform: 'translate(0px, 2px)'
        } }, (props.active ? activeStyle : defaultStyle));
});
var StyledIconButtonOutlined = styled_1.default.button(function (props) {
    var defaultStyle = {
        backgroundColor: styles_1.palette['white-base'],
        color: props.secondary ? styles_1.palette['coral-base'] : styles_1.palette['blue-base']
    };
    var activeStyle = props.secondary
        ? {
            backgroundColor: styles_1.palette['coral-darker-40'],
            borderColor: styles_1.palette['coral-darker-40'],
            transform: 'translate(0px, 2px)',
            '&:hover:enabled': {}
        }
        : {
            backgroundColor: styles_1.palette['blue-darker-40'],
            borderColor: styles_1.palette['blue-darker-40'],
            transform: 'translate(0px, 2px)',
            '&:hover:enabled': {}
        };
    return __assign({ color: styles_1.palette['white-base'], height: '40px', width: '40px', padding: '6px', borderRadius: '20px', borderWidth: '2px', borderStyle: 'solid', borderColor: props.secondary ? styles_1.palette['coral-base'] : styles_1.palette['blue-base'], '&:focus': {
            outline: 'none'
        }, '&:disabled': {
            backgroundColor: styles_1.palette['stone-lighter-40'],
            borderColor: styles_1.palette['stone-lighter-40'],
            color: styles_1.palette['stone-darker-20'],
            cursor: 'not-allowed'
        }, '&:hover:enabled': {
            backgroundColor: props.secondary ? styles_1.palette['coral-darker-20'] : styles_1.palette['blue-darker-20'],
            borderColor: props.secondary ? styles_1.palette['coral-darker-20'] : styles_1.palette['blue-darker-20'],
            color: styles_1.palette['white-base'],
            cursor: 'pointer'
        }, '&:active:enabled': {
            backgroundColor: props.secondary ? styles_1.palette['coral-darker-40'] : styles_1.palette['blue-darker-40'],
            borderColor: props.secondary ? styles_1.palette['coral-darker-40'] : styles_1.palette['blue-darker-40'],
            transform: 'translate(0px, 2px)'
        } }, (props.active ? activeStyle : defaultStyle));
});
//# sourceMappingURL=IconButton.js.map